// Subset of https://raw.githubusercontent.com/sindresorhus/spdx-license-list/main/spdx.json

const Licenses = {
	"CC-PDDC": {
		"name": "Creative Commons Public Domain Dedication and Certification",
		"url": "https://creativecommons.org/licenses/publicdomain/"
	},
	"CC-BY-SA-4.0": {
		"name": "Creative Commons Attribution Share Alike 4.0 International",
		"url": "https://creativecommons.org/licenses/by-sa/4.0/legalcode"
	},
	"CC-BY-4.0": {
		"name": "Creative Commons Attribution 4.0 International",
		"url": "https://creativecommons.org/licenses/by/4.0/legalcode"
	},
	"CC0-1.0": {
		"name": "Creative Commons Zero v1.0 Universal",
		"url": "https://creativecommons.org/publicdomain/zero/1.0/legalcode"
	},
	"CC-BY-ND-4.0": {
		"name": "Creative Commons Attribution No Derivatives 4.0 International",
		"url": "https://creativecommons.org/licenses/by-nd/4.0/legalcode"
	},
	"CC-BY-3.0": {
		"name": "Creative Commons Attribution 3.0 Unported",
		"url": "https://creativecommons.org/licenses/by/3.0/legalcode"
	},
	"CC-BY-NC-4.0": {
		"name": "Creative Commons Attribution Non Commercial 4.0 International",
		"url": "https://creativecommons.org/licenses/by-nc/4.0/legalcode"
	},
	"CC-BY-NC-SA-4.0": {
		"name": "Creative Commons Attribution Non Commercial Share Alike 4.0 International",
		"url": "https://creativecommons.org/licenses/by-nc-sa/4.0/legalcode"
	},
	"CC-BY-NC-ND-4.0": {
		"name": "Creative Commons Attribution Non Commercial No Derivatives 4.0 International",
		"url": "https://creativecommons.org/licenses/by-nc-nd/4.0/legalcode"
	},
	"ISC": {
		"name": "ISC License",
		"url": "https://www.isc.org/licenses/"
	},
	"proprietary": {
		"name": "Proprietary",
		"url": "https://en.wikipedia.org/wiki/Proprietary_software"
	}
};

export { Licenses };